export default __webpack_public_path__ + "static/media/Pot1.bf111942.svg";